module.exports = __webpack_public_path__ + "static/media/exit-modal-flex-plus-2x.b8344d3a.png";